'use strict';
moduleConfig.registerModule('eclipseApp.components', ['eclipseApp.core']);
